<template>
    <div class="TrainingSessionManage">
        <v-card>
        <v-toolbar flat color="grey lighten-4">

            <v-btn @click="createDialog = true">
                Add Session
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-toolbar>

            <v-card-text>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left">Date</th>
                    <th class="text-left">Start</th>
                    <th class="text-left">Finish</th>
                    <th class="text-left">Trainer</th>
                    <th class="text-left">Location</th>
                    <th class="text-left">PO's</th>
                    <th class="text-left"></th>

                </tr>
                </thead>
                <tbody>
                <tr v-for="session in model.sessions" :key="session.id">
                    <td>{{ session.date|formatDate }}</td>
                    <td>{{ session.start|formatDate('hh:mm') }}</td>
                    <td>{{ session.finish|formatDate('hh:mm') }}</td>
                    <td>{{ session.trainer.firstName }} {{ session.trainer.lastName }}</td>
                    <td>{{ session.location}} <span v-if="session.locationDetail">({{session.locationDetail}})</span>
                    <td>
                        <span v-for="poDetails in getPoNumbers(session.purchaseOrderDetails)" :key="poDetails.id">
                            <v-btn
                                    class="mr-2"
                                    small
                                    :to="{name: 'purchase-order-view', params:{id: poDetails.id}}"
                            >
                                <template v-if="poDetails.xeroPoNumber">
                                {{poDetails.xeroPoNumber}}
                                </template>
                                <template v-else>
                                    PO-{{poDetails.id}}
                                </template>


                            </v-btn>
                        </span>
                    </td>
                    <td>

                        <v-btn class="ma-2" @click="updateSession(session)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn  class="ma-2" color="error" @click="deleteSession(session)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>

                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
            </v-card-text>
        </v-card>
        <confirm ref="confirm"></confirm>

        <v-dialog v-model="createDialog" persistent max-width="600px">
            <TrainingSessionsForm
                    :class-id="model.id"
                    @clickClose="createDialog = false"
                    @complete="completedCreateUpdateSession"
                    @errors="pushErrors"
            >
            </TrainingSessionsForm>
        </v-dialog>

        <v-dialog v-model="updateDialog" persistent max-width="600px">
            <TrainingSessionsForm
                    :class-id="parseInt(model.id)"
                    :selected-session="selectedSession"
                    @clickClose="updateDialog = false"
                    @complete="completedCreateUpdateSession"
                    @errors="pushErrors"
            >
            </TrainingSessionsForm>
        </v-dialog>

    </div>
</template>
<script>
    import moment from "moment"
    import TrainingSessionsForm from "./TrainingSessionForm"
    import Confirm from "../../Confirm"
    import TRAINING_SESSION_DELETE from "../../../graphql/TrainingSessionsDelete.gql";

    export default {
        components: {
            TrainingSessionsForm,
            Confirm,
        },
        data() {
            return {
                createDialog: false,
                updateDialog: false,
                date: null,
                selectedSession: null,
                updating: false,
            }
        },
        props: {
            model: Object,
        },
        watch: {
            updating(val) {
                this.$emit('updating', val);
            }
        },
        methods: {

            updateSession(session)
            {
                this.selectedSession = session
                this.updateDialog = true
            },

            deleteSession(session){
                this.$refs.confirm
                    .open('Delete', 'Are you sure?', { color: 'red' })
                    .then((confirm) => {
                        if(confirm) {
                            this.$apollo.mutate({
                                mutation: TRAINING_SESSION_DELETE,
                                variables: {id: session.id},
                            }).then(() => {
                                this.updating = false
                                this.pushSaved()
                            }).catch((graphQLErrors) => {
                                const errors = Object.keys(graphQLErrors).map((key) => graphQLErrors[key].debugMessage)
                                this.pushErrors(errors)
                            })
                        }

                    })
            },
            pushSaved(){
                this.$emit('saved')
            },
            pushErrors(errors) {
                this.$emit('errors', errors)
            },

            completedCreateUpdateSession(){
                this.createDialog = false
                this.updateDialog = false
                this.pushSaved()
            },

            getPoNumbers(poDetails){

                let poNumbers = [];
                let pos = [];
                poDetails.forEach((item) => {
                    let id = item.purchaseOrder.id
                    if(poNumbers.indexOf(id) === -1){
                        poNumbers.push(id)
                        pos.push({id: id, xeroPoNumber: item.purchaseOrder.xeroPoNumber})
                    }
                })

                return pos;
            },

            formatDate(date){
                return moment(date).format('ddd mmm yyyy')
            },
        }
    };
</script>
